module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/banco-inter-logo-e60fb639a462021b66a7fabad2eaca92.svg";